export default __webpack_public_path__ + "static/media/podium.528acbb1.png";